import DOMElement from "../../../../../components/base/dom-element";

export default class CheckoutSidebarPriceListElement extends DOMElement {
    constructor(props) {
        super('ul', props);
    }

    _setProps() {
        super._setProps();

        this.class = DOMElement.classListFrom('checkout-price-list', this.class);
        this.initialPrice = this.props.initialPrice;
        this.finalPrice = this.props.finalPrice;
        this.items = this.props.items || [];
    }

    _initProps() {
        super._initProps();

        this.children = [
            ...(this.initialPrice ? [this._getItem(this.initialPrice)] : []),
            ...this.items.map((item) => this._getItem(item)),
            ...(this.finalPrice ? [this._getItem(this.finalPrice, true)] : [])
        ];
    }

    _getItem(item, final) {
        return new DOMElement('li', {
            class: ['checkout-price-list-item', 'checkout-price-list_item', ...(final === true ? ['-total'] : [])],
            children: [
                new DOMElement('div', {
                    class: 'checkout-price-list-item-group',
                    children: [
                        ...(item.name ? [new DOMElement('span', {
                            class: 'checkout-price-name',
                            text: item.name
                        })] : []),
                        ...(item.amount ? [new DOMElement('span', {
                            class: 'checkout-price-amount',
                            text: item.amount
                        })] : [])
                    ]
                }),
                ...(item.sublist && item.sublist.length ? [new DOMElement('ul', {
                    class: 'checkout-price-sublist',
                    children: item.sublist.map((subitem) => new DOMElement('li', {
                        class: 'checkout-price-sublist-item checkout-price-sublist_item',
                        text: subitem.label
                    }))
                })] : [])
            ]
        });
    }

}